import { css, jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import React from 'react';

import Background from './Background';
import Title from './Title';

const index = ({ profile }) => {
  const { Name, Division, Picture } = profile;

  return (
    <div>
      <Title
        data={{
          division: Division,
          name: Name,
          title: profile.Title,
          image: Picture,
        }}
      />
      <Background background={profile.Background} />
    </div>
  );
};

index.propTypes = {};

export default index;
